import { Target, Zap, Rocket, Users, BarChart3 } from 'lucide-react';

export const principles = [
  {
    icon: Target,
    title: 'Outcome-First Design',
    description: 'We design backward from your business goals, not forward from technology trends. Every initiative is measured by impact.',
  },
  {
    icon: Zap,
    title: 'Speed With Control',
    description: 'We deliver in weeks, not quarters. Rapid execution without sacrificing stability, security, or governance.',
  },
  {
    icon: Rocket,
    title: 'AI That Ships',
    description: 'Production-grade AI systems, not prototypes. Scalable, secure, auditable — no POC purgatory.',
  },
  {
    icon: Users,
    title: 'Embedded Partnership',
    description: 'We integrate with your teams, share accountability, and stay invested until outcomes are delivered.',
  },
  {
    icon: BarChart3,
    title: 'Measurable Outcomes',
    description: 'Clear metrics, regular reporting, transparent tracking. Scorecards replace slideware.',
  },
];

export const executionStats = [
  { value: '2×/week', label: 'Formal Client Reviews' },
  { value: '15 min/day', label: 'Daily Scrums' },
  { value: 'Clear RACI', label: 'Ownership Matrices' },
];

export const painPoints = [
  {
    text: 'AI initiatives stuck in proof-of-concept purgatory, never reaching production',
    impact: '87% of AI projects never make it past the pilot stage, burning an average of $1.2M per failed initiative.',
    severity: 92,
  },
  {
    text: 'Fragmented SaaS ecosystems creating operational complexity and inefficiency',
    impact: 'Enterprises manage 130+ SaaS tools on average, with 30% overlap and zero integration strategy.',
    severity: 78,
  },
  {
    text: 'Slow execution cycles caused by unclear ownership and weak delivery frameworks',
    impact: 'Projects take 2.5× longer than estimated. Lack of clear RACI leads to decision paralysis.',
    severity: 85,
  },
  {
    text: 'High consulting expenditures with minimal measurable ROI or business outcomes',
    impact: 'Organizations spend $500K+ annually on consulting retainers that produce slide decks, not shipped code.',
    severity: 70,
  },
  {
    text: 'Technology decisions made in isolation from strategic business objectives',
    impact: 'CTO and CIO priorities misalign with revenue goals in 60% of digital transformation programs.',
    severity: 65,
  },
];
